import { makeAsync } from '@citrite/workspace-ui-platform-react';

export const AboutWorkspace = makeAsync(() =>
	import('./About').then(m => m.AboutWorkspace)
);
